import ContactModel from "donor-elf-web/models/contact";
import type ContactsCache from "donor-elf-web/services/contacts-cache";
import { Changeset } from 'ember-changeset';
import lookupValidator from "ember-changeset-validations";
import validateContact from 'donor-elf-web/validations/contact';
import validateContactCustomProperty from 'donor-elf-web/validations/contact-custom-property';
import type { ContactCustomPropertyInfo } from "donor-elf-web/services/contacts-cache";
import { isEmpty, isPresent } from "@ember/utils";

export type MergePropertyInfo = {
  property: keyof ContactModel;
  label: string;
  boolean?: true;
}

export const MergeProperties: MergePropertyInfo[] = [{
  property: 'name',
  label: 'Name'
}, {
  property: 'firstName',
  label: 'First Name'
}, {
  property: 'lastName',
  label: 'Last Name'
}, {
  property: 'deceased',
  label: 'Deceased',
  boolean: true
}, {
  property: 'spouseFirstName',
  label: 'Spouse First Name'
}, {
  property: 'spouseLastName',
  label: 'Spouse Last Name'
}, {
  property: 'spouseDeceased',
  label: 'Spouse Deceased',
  boolean: true
}, {
  property: 'mailingName',
  label: 'Mailing Name'
}, {
  property: 'greeting',
  label: 'Greeting'
}]

export const AddressProperties: MergePropertyInfo[] = [{
  property: 'address1',
  label: 'Street 1'
}, {
  property: 'address2',
  label: 'Street 2'
}, {
  property: 'city',
  label: 'City'
}, {
  property: 'state',
  label: 'State'
}, {
  property: 'zip',
  label: 'Zip'
}, {
  property: 'country',
  label: 'Country'
}]

export function createMergeChangesetFromContact(contact: ContactModel) {
  const object: any = {};
  for (const item of MergeProperties) {
    object[item.property] = contact[item.property];
  }
  for (const item of AddressProperties) {
    object[item.property] = contact[item.property];
  }
  object.groups = [...contact.groups || []]
  object.phones = structuredClone(contact.phones)
  object.emails = structuredClone(contact.emails);
  object.custom = structuredClone(contact.custom);
  object.addNameToTasks = false;
  object.addNameToPledges = false;
  return Changeset(
    object,
    lookupValidator(validateContact),
    validateContact
  );
}

export function createCustomPropertyChangeset(args: { contactToKeep: ContactModel, contactToMerge: ContactModel, contactsCache: ContactsCache, customPropertyInfo: ContactCustomPropertyInfo }) {
  const { contactToKeep, contactToMerge, contactsCache, customPropertyInfo } = args;
  let validation = validateContactCustomProperty({ contactsCache, isNewProperty: false, allowEmptyVal: true });
  const contactToKeepValue = contactToKeep.customPropertyValue(customPropertyInfo.l);
  const contactToMergeValue = contactToMerge.customPropertyValue(customPropertyInfo.l);

  let value = contactToKeepValue;
  if (customPropertyIsMultipleSelectionList(customPropertyInfo)) {
    // combine values from both contacts
    value = {
      ...(contactToKeepValue || {}),
      ...(contactToMergeValue || {})
    }
  } else if (isEmpty(value) && isPresent(contactToMergeValue)) {
    value = contactToMergeValue;
  }

  return Changeset({
    l: customPropertyInfo.l,
    t: customPropertyInfo.t,
    v: value,
  }, lookupValidator(validation), validation);
}

function customPropertyIsMultipleSelectionList(customPropertyInfo: ContactCustomPropertyInfo) {
  return (
    customPropertyInfo.t === 'l' &&
    customPropertyInfo.s?.single_selection !== true
  );
}
